var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgRingtone = function SvgRingtone(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 17.3 19.2",
    style: {
      enableBackground: "new 0 0 17.3 19.2"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#698DB0",
    d: "M17.1,0.1C16.9,0,16.7,0,16.5,0L5.6,3.5C5.4,3.6,5.2,3.8,5.2,4.1v10.4C4.6,14.2,4,14,3.2,14 c-0.8,0-1.6,0.2-2.2,0.7c-0.7,0.5-1,1.2-1,1.9c0,0.7,0.4,1.4,1,1.9c0.6,0.5,1.4,0.7,2.2,0.7c0.8,0,1.6-0.2,2.2-0.7 c0.7-0.5,1-1.2,1-1.9V8.2l9.6-3v5.9c-0.6-0.3-1.2-0.5-2-0.5c-0.8,0-1.6,0.2-2.2,0.7c-0.7,0.5-1,1.2-1,1.9c0,0.7,0.4,1.4,1,1.9 c0.6,0.5,1.4,0.7,2.2,0.7c0.8,0,1.6-0.2,2.2-0.7c0.7-0.5,1-1.2,1-1.9V0.6C17.3,0.4,17.2,0.2,17.1,0.1z M16.1,1.5v2.3l-9.6,3V4.6 L16.1,1.5z M16.1,13.1c0,0.7-0.9,1.3-2,1.3c-1.1,0-2-0.6-2-1.3c0-0.7,0.9-1.3,2-1.3S16.1,12.4,16.1,13.1z M5.2,16.6 c0,0.7-0.9,1.3-2,1.3c-1.1,0-2-0.6-2-1.3c0-0.7,0.9-1.3,2-1.3C4.3,15.3,5.2,15.9,5.2,16.6z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRingtone, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ringtone.dc2ac9c6.svg";
export { ForwardRef as ReactComponent };